<template>
  <div class="yh-page" style="background-color: white;">
    <el-form  ref="form" label-width="120px">
      <el-form-item label="保单内容">
      <el-row>
        <el-col :span="8">
          <label>保险单号：{{ policy.policy_number }}</label>
        </el-col>
        <el-col :span="8">
          <label>保险公司：{{ policy.insurance_company_branch_office }}</label>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <label>保险类型：{{ policy.insurance_type }}</label>
        </el-col>
        <el-col :span="8">
          <label>保险期限：{{ policy.effective_date }} 至 {{ policy.expiration_date }}</label>
        </el-col>
      </el-row>
      </el-form-item>
      <el-form-item label="* 批改类型">
        <el-radio-group v-model="correct_type">
          <el-radio :label="'1'">批改（不涉及保费变化）</el-radio>
          <el-radio :label="'2'">退保</el-radio>
          <el-radio :label="'3'">加保</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="加保/退保费用" v-if="['2', '3'].indexOf(correct_type) !== -1">
        <el-input type="number" v-model="premium" style="width: 10%" @input="EditPremium"></el-input> 元
      </el-form-item>

      <el-form-item label="账户信息" prop="account"  v-if="['2', '3'].indexOf(correct_type) !== -1">
            <el-select v-model="account" placeholder="请选择账户"
             filterable @change="handleAccountInfo" value-key="id"
            >
              <el-option v-for="c in accounts" :key="c.name"
                  :label="'账户：'+ c.account + '   开户地址：' + c.address" :value="c.name"></el-option>
            </el-select>
      </el-form-item>

      <el-form-item v-if="correct_type==='2'" label="* 退保信息">
        <el-input type="textarea" style="width: 80%" :autosize="{ minRows: 4, maxRows: 8}"
          v-model="refund_info"
          placeholder="请填写退保信息">
        </el-input>
      </el-form-item>
      <el-form-item label="* 批改原因">
        <el-input v-model="reason" style="width: 80%"></el-input>
      </el-form-item>
      <el-form-item label="生效日期">
        <el-date-picker
          v-model="start_date"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="签署日期">
        <el-date-picker
          v-model="sign_date"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="批改内容" v-if="correct_type!=='2'">
      <br/>
      <el-row style="font-weight: bold;">
        <el-col :span="4">
          <label>项目</label>
        </el-col>
        <el-col :span="7">
          <label>变更前内容</label>
        </el-col>
        <el-col :span="10">
          <label>变更后内容</label>
        </el-col>
      </el-row>
      <el-row v-for="item in correct_item" :key="item.key">
        <el-col :span="4">
          <el-switch
            v-model="item.is_checked"
            @change="handleChange(item)"
            active-color="#13ce66"
            inactive-color="#ff4949">
          </el-switch>
          &nbsp;
          <label>{{ item.name + (item.company ? "（" + item.company + "）" : "") }}</label>
        </el-col>
        <el-col v-if="item.can_edit" :span="7">
          <el-input style="width: 82%" :disabled="! item.is_checked"
            :type="item.type" v-model="item.before" />
        </el-col>
        <el-col v-else :span="7">
          <label>{{ item.before }}</label>
        </el-col>
        <el-col :span="10">
          <el-input style="width: 82%" :disabled="! item.is_checked"
            :type="item.type" v-model="item.after" />
        </el-col>
      </el-row>
      <el-row v-if="correct_type!=='2'">
        <el-col>
          <el-switch
            v-model="other_change.is_checked"
            active-color="#13ce66"
            inactive-color="#ff4949">
          </el-switch>
          &nbsp;
          <label>其他批改内容</label>
          <br/>
          <el-input type="textarea" style="width: 80%" :autosize="{ minRows: 4, maxRows: 8}"
                :disabled="! other_change.is_checked" v-model="other_change.text"
                placeholder="格式如本保单第一收益人由“XXXX”变更为“XXXXXXX”"></el-input>
        </el-col>
      </el-row>
      </el-form-item>
      <!-- <el-form-item label="附件" prop="attachments" v-if="correct_id">
        <div>
          <attachment-list object-type="correct.correct"
                            :object-id="correct_id"
                            :file-list="file_list" :allow-delete="opera_type !== 'ViewCorrect'"
                            :attachment-name="attachment_name"
                            @removed="loadFileList('correct.correct', correct_id)"
                            class="mr-3"></attachment-list>
          <el-button v-if="opera_type !== 'ViewCorrect'" type="primary" size="mini" @click="handleUpload">上传</el-button>
        </div>
      </el-form-item> -->
      <el-form-item label="附件" prop="attachments" v-if="correct_id">
        <select-file-list object_type="correct.correct" :object="correct_id" :insurance="new_attachment_name"
                          :file-list.sync="file_list"
                          :allow-delete="false"></select-file-list>
        <el-button type="primary" size="mini" @click="handleSelect">选择</el-button>
      </el-form-item>
      <el-form-item>
      <el-row>
        <el-col>
          <el-button @click="() => {this.$router.go(-1)}">
            <label>取消</label>
          </el-button>
          <el-button v-if="opera_type !== 'ViewCorrect'" @click="handleSave(1)">
            <label>保存</label>
          </el-button>
          <el-button v-if="opera_type !== 'ViewCorrect'" @click="handleSave(2)">
            <label>保存并提交</label>
          </el-button>
        </el-col>
      </el-row>
      </el-form-item>
    </el-form>
    <upload-dialog ref="upload"
                   :object-name="object_name"
                   :file-type-list="file_type_list"
                   object-type="correct.correct"
                   :object-id="correct_id"
                   :ship-list="shipList"
                   :customer-list="customerList"
                   :is-upload="true"
                   :default-issue-date.sync="default_issue_date"
                   :default-expire-date.sync="default_expire_date"
                   @uploaded="loadFileList('correct.correct', correct_id)">
    </upload-dialog>
    <select-file-dialog ref="select"
                        :object-name="object_name"
                        object-type="correct.correct"
                        :object-id="correct_id"
                        :file-type-list="file_type_list"
                        :ship-list="shipList" 
                        :customer-list="customerList"
                        :default-issue-date="default_issue_date"
                        :default-expire-date="default_expire_date"
                        :file-list.sync="file_list"
                        :allow-delete="opera_type !== 'ViewCorrect'"
                        :append-to-body="true">
    </select-file-dialog>
  </div>
</template>

<script>
import {
  fetchFileTypeList,
  getObjectFileAll
} from "@/api/common"
import { createCorrect, UpdateCorrectDetail, SubmitCorrect, getShipOrCustomerList} from '@/api/correct'
import { Form } from 'element-ui';
import AttachmentList from "@/components/AttachmentList"
import UploadDialog from "@/components/UploadDialog"
import SelectFileList from "@/components/SelectFileList"
import SelectFileDialog from '@/components/SelectFileDialog'
import {getAccount} from '@/api/customer'

export default {
  name: "correct-apply",
  components: {
      // AttachmentList,
      UploadDialog,
      SelectFileList,
      SelectFileDialog,
    },
  computed: {
    selected_list() {
      let selected_list = this.file_list.filter(file => {
        return file.checked
      })

      return selected_list
    },
  },
  data() {
    return {
      object_name: '',
      file_type_list: '',
      file_list: [],
      attachment_name: '附件.zip',
      new_attachment_name: {'name': '附件'},
      default_issue_date: '',
      default_expire_date: '',
      opera_type: "",
      correct_id: "",
      policy: "",
      account:'',
      accounts:[],
      customerList:[],
      shipList:[],
      correct_type: "",
      reason: "",
      refund_info: "请将保费\n退至以下账号，账号信息如下：\n开户名称：\n账号：\n开户行：",
      premium: 0,
      start_date: null,
      sign_date: null,
      correct_item: [
        {
          "key": "administrator",
          "is_checked": false,
          "name": "管理人",
          "type": "text",
          "before": "",
          "after": "",
          "company": "平安",
          "can_edit": true
        },
        {
          "key": "beneficiary",
          "is_checked": false,
          "name": "受益人",
          "type": "text",
          "before": "",
          "after": "",
          "company": "平安",
          "can_edit": true
        },
        {
          "key": "insured",
          "is_checked": false,
          "name": "被保险人名称",
          "type": "text",
          "before": "",
          "after": "",
          "company": ""
        },
        {
          "key": "ship_name",
          "is_checked": false,
          "name": "船舶名称",
          "type": "text",
          "before": "",
          "after": "",
          "company": ""
        },
        {
          "key": "sailing_area",
          "is_checked": false,
          "name": "航行区域",
          "type": "text",
          "before": "",
          "after": "",
          "company": ""
        },
        {
          "key": "total_tons",
          "is_checked": false,
          "name": "总吨",
          "type": "number",
          "before": "",
          "after": "",
          "company": ""
        }
      ], //批改内容
      other_change: {
        "is_checked": false,
        "text": ""
      } //其他批改
    }
  },
  methods: {
    handleAccountInfo(item){
      let account = this.accounts.find((a) => {return a.name === item})
      this.refund_info = "请将保费\n退至以下账号，账号信息如下：\n开户名称：" + account.name + "\n账号："+account.account+"\n开户行：" + account.address
    },
    EditPremium(value) {
      if (this.correct_type === "2" && value > 0){
        this.premium = -value
      }
      else if (this.correct_type === "3" ){
        this.premium = Math.abs(value)
      }
      else {
        this.premium = value
      }
    },
    loadData() {
      this.opera_type = this.$route.params.type
      if (this.opera_type === "NewCorrect") {
        this.policy = this.$route.params.data
        getAccount({'insured':this.policy.insured,'applicant':this.policy.applicant}).then(res => {
              this.accounts = res
            })
        this.correct_item.forEach(item => {
          if (this.policy[item.key]) {
            item.before = this.policy[item.key]
          }
        });
      }

      else if (this.opera_type === "EditCorrect" || this.opera_type === "ViewCorrect") {
        let correct_data = this.$route.params.data
        this.correct_id = correct_data.id
        this.policy = correct_data.policy_table_dic
        this.correct_type = correct_data.type
        this.reason = correct_data.reason
        this.premium = correct_data.premium
        this.start_date = correct_data.start_date
        this.sign_date = correct_data.sign_date
        this.other_change = correct_data.other_change
        if (correct_data.refund_info) {
          this.refund_info = correct_data.refund_info
        }
        
        const obj = correct_data.change_content
        this.correct_item.forEach(item => {
          if (obj[item.key]) {
            for (var key in item) {
              this.$set(item, key, obj[item.key][key])
            }
          }
        });
        this.object_name = this.policy.policy_number
        this.attachment_name = this.policy.policy_number + '.zip'
        this.new_attachment_name.name = this.policy.policy_number
        fetchFileTypeList({file_type: "bc|sc|cc"}).then(res => {
          this.file_type_list = res
          this.loadFileList('correct.correct', this.correct_id)
        })
        getAccount({'insured':this.policy.insured,'applicant':this.policy.applicant}).then(res => {
          this.accounts = res
        })
        getShipOrCustomerList(this.$route.params.data.change_content)
        .then(res => {
          // console.log(res)
          this.shipList = res.ship_list
          this.customerList = res.customer_list
        })
        .catch(error => {
          this.$message.error(error)
        })
    }

    },
    handleChange(item) {
      if (! item.is_checked){
        item.after = ""
      }
    },
    handleSave(save_type) {
      // 包含保存、保存并提交两个逻辑，根据save_type判断是否作提交动作
      let submitForm = new Object()
      let change_content = new Object()

      this.$set(submitForm, 'policy_table', this.policy.id)
      this.$set(submitForm, 'reason', this.reason)
      this.$set(submitForm, 'type', this.correct_type)
      this.$set(submitForm, 'refund_info', this.correct_type === '2' ? this.refund_info : '')
      this.$set(submitForm, 'start_date', this.start_date)
      this.$set(submitForm, 'sign_date', this.sign_date)
      this.$set(submitForm, 'other_change', this.other_change) 

      if (['2', '3'].indexOf(this.correct_type) !== -1) {
        this.$set(submitForm, 'premium', this.premium)
      }

      this.correct_item.forEach(item => {
        change_content[item.key] = item
      })
      this.$set(submitForm, 'change_content', change_content)

      if (this.opera_type === "NewCorrect") {
        createCorrect(submitForm)
        .then(res => {
          this.$nextTick(() => {
            console.log('创建对象返回id：',res['id'])
            this.$message({
              type: 'success',
              message: '批改申请保存成功!'
            });
            setTimeout(() => {
              if (save_type === 2) {
                this.handleSubmit(res['id'])
              }
              else {
                this.$router.push({name: "correctList"})
              }
            }, 1000)
          })
        })
        .catch(err => {
          this.$error_message(err)
        })
      }
      else if (this.opera_type === "EditCorrect") {
        this.$set(submitForm, 'selected_files', this.selected_list)
        UpdateCorrectDetail(this.correct_id, submitForm)
        .then(res => {
          this.$nextTick(() => {
            this.$message({
              type: 'success',
              message: '批改申请保存成功!'
            });
            setTimeout(() => {
              if (save_type === 2) {
                this.handleSubmit(this.correct_id)
              }
              else {
                this.$router.push({name: "correctList"})
              }
            }, 1000)
          })
        })
        .catch(err => {
          this.$error_message(err)
        })
      }
    },
    handleSubmit(id) {
      SubmitCorrect(id)
      .then(res => {
        this.$nextTick(() => {
          this.$message({
            type: 'success',
            message: '提交成功!'
          });
          setTimeout(() => {
            this.$router.push({name: "correctList"})
          }, 1000)
        })
      })
      .catch(err => {
        console.log(err)
        this.$error_message("提交失败！")
      })
    },
    loadFileList(object_type, object_id) {
      getObjectFileAll(object_type, object_id)
        .then(res => {
          this.file_list = res
          this.file_list.forEach(item => {
            let file_type_obj = this.file_type_list.find(type => {
              return (type.code === item.file_type)
            })
            if (file_type_obj && item.file_date) {
              if (file_type_obj.date_type === 'F') {
                this.default_issue_date = item.file_date
              } else {
                this.default_expire_date = item.file_date
              }
            }
            this.$set(item, 'checked', true)
          })
        })
        .catch(error => {
          this.$error_message(error)
        })
    },
    handleUpload() {
      this.$refs.upload.handleOpen()
    },
    handleSelect() {
      this.$refs.select.handleSelect()
    },
  },
  beforeRouteLeave(to, from, next) {
        if (to.name != 'correctList') {
          window.localStorage.removeItem('query')
        }
        next()
        },
  created() {
    this.loadData()

  }
}
</script>